type IMessageFuncs = (message: string) => void;
type IErrorFuncs = (error: Error) => void;
type ISetAttribute = (attribs: Record<string, object | string>) => void;
const LogHandler = () => {
  // LOCAL LOGGER AS FALLBACK
  let logger = (message: string) => { console.log('fall', message) }
  let recordError = (error: Error) => { console.log('fall', error) };
  let setAttributes = (attribs: Record<string, object | string>) => { };
  let crasher = () => { }
  let context: any = null;

  const init = (
    _context: any,
    _crasher: () => void,
    _recordError: IErrorFuncs,
    _logger: IMessageFuncs,
    _setAttributes: ISetAttribute,
  ) => {
    logger = _logger;
    crasher = _crasher;
    recordError = _recordError;
    setAttributes = _setAttributes;
    context = _context;
  }

  const crash = () => {
    crasher?.()
  }
  const log = (message: string) => {
    logger?.(message);
  }
  const logRecordError = (error: Error) => {
    recordError?.(error);
  }
  const setAttribs = (attribs: Record<string, object | string>) => {
    setAttributes?.(attribs);
  }

  return { init, crash, log, logRecordError, setAttribs };
}

export default LogHandler();